var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 13.3333C5.74603 13.3333 4.99984 14.0795 4.99984 15V31.6667C4.99984 32.5871 5.74603 33.3333 6.6665 33.3333H33.3332C34.2536 33.3333 34.9998 32.5871 34.9998 31.6667V15C34.9998 14.0795 34.2536 13.3333 33.3332 13.3333H6.6665ZM1.6665 15C1.6665 12.2386 3.90508 10 6.6665 10H33.3332C36.0946 10 38.3332 12.2386 38.3332 15V31.6667C38.3332 34.4281 36.0946 36.6667 33.3332 36.6667H6.6665C3.90508 36.6667 1.6665 34.4281 1.6665 31.6667V15Z",
    fill: "#03E287"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.131 4.79747C14.0687 3.85979 15.3404 3.33301 16.6665 3.33301H23.3332C24.6593 3.33301 25.931 3.85979 26.8687 4.79747C27.8064 5.73516 28.3332 7.00692 28.3332 8.33301V34.9997C28.3332 35.9202 27.587 36.6663 26.6665 36.6663C25.746 36.6663 24.9998 35.9202 24.9998 34.9997V8.33301C24.9998 7.89098 24.8242 7.46706 24.5117 7.1545C24.1991 6.84194 23.7752 6.66634 23.3332 6.66634H16.6665C16.2245 6.66634 15.8006 6.84194 15.488 7.1545C15.1754 7.46706 14.9998 7.89098 14.9998 8.33301V34.9997C14.9998 35.9202 14.2536 36.6663 13.3332 36.6663C12.4127 36.6663 11.6665 35.9202 11.6665 34.9997V8.33301C11.6665 7.00692 12.1933 5.73516 13.131 4.79747Z",
    fill: "#03E287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.2540229fa30b4c76b90fe083c5e32347.svg";
export { ForwardRef as ReactComponent };